import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/flightSeatsMap', request)
}

export {get}
